import React, { memo } from 'react';
import { Popover } from '@patternfly/react-core';
import { InfoAltIcon } from '@patternfly/react-icons';

/* =========================
 * Tipos genéricos de fila
 * ========================= */

export interface RowItem {
  id: number | string;
  name: string;
  spot?: any;
}

export interface RowColumnProps {
  rows: RowItem[];
  rowHeights: Map<number | string, number>;
}

function SpotDetails({ spot }: { spot: any }) {
  return (
    <div style={{ maxWidth: 300 }}>
      {spot.address && <div><b>Dirección:</b> {spot.address}</div>}
      {spot.city && <div><b>Ciudad:</b> {spot.city}</div>}
      {spot.observations && <div><b>Observaciones:</b> {spot.observations}</div>}
      {spot.requiredSkillSet?.length > 0 && (
        <div style={{ marginTop: 6 }}>
          <b>Habilidades requeridas:</b>
          <div style={{ marginTop: 4, color: '#555' }}>
            {spot.requiredSkillSet.map((skill: any) => skill.name).join(', ')}
          </div>
        </div>
      )}
    </div>
  );
}

/* =========================
 * Component
 * ========================= */

function RowColumn({
  rows,
  rowHeights,
}: RowColumnProps) {
  return (
    <div
      className="schEmployees"
    >
      <div
        className="schEmployees__body"
      >
        {/* Spacer superior (virtualización) */}
        <div/>

        {rows.map((row) => (
          <div
            key={row.id}
            className="schEmployees__row"
            style={{ height: rowHeights.get(row.id) }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div className="empName">{row.name}</div>
              </div>

              {row.spot && (
                <Popover
                  headerContent="Detalles del puesto"
                  bodyContent={<SpotDetails spot={row.spot} />}
                  appendTo={() => document.body}
                >
                  <button
                    style={{
                      border: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      fontSize: 14,
                      opacity: 0.6
                    }}
                  >
                    <InfoAltIcon/>
                  </button>
                </Popover>
              )}
            </div>
            
          </div>
        ))}
      </div>
    </div>
  );
}

export default memo(RowColumn);
